import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../../auth/service/auth.service';
import { ToastNotificationService } from '../../../shared/toast-notification.service';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetBlockerService {

  apiUrl: string = environment.apiUrl;
  testApi = 'https://test.api.tridimo.de/api/';
  devApi = 'https://dev.api.tridimo.de/api/';
  storedData: any

 constructor(private http: HttpClient, private authService: AuthService, private toastService: ToastNotificationService) { }

 async getStoredData() {
   this.storedData = localStorage.getItem("authUser"); 
 }

 checkToken(token: any) {
   try {
     const expirationTime = token * 1000;
     const currentTime = Date.now();
     if (currentTime > expirationTime) {
       console.log('Token ist älter als 60 Minuten');
       this.logout()
     } else {
       console.log('Token ist noch gültig');
     }
   } catch (e) {
     console.error('Fehler beim Dekodieren des Tokens:', e);
     this.logout()
   }
 }

 setFetchOptions() {
  let options: any = {};
  
  if (this.apiUrl === this.devApi ) {
    let token = "";
    let exp = '';
    this.getStoredData();
    if (this.storedData) {
      try {
        const parsedData = JSON.parse(this.storedData);
        token = parsedData.token;
        exp = parsedData.exp;
        this.checkToken(exp);
      } catch (error) {
        console.error("Fehler beim Parsen des Tokens:", error);
        this.logout();
      }
    } else {
      this.logout();
      console.log("Kein Token im Local Storage gefunden.");
    }

    const headers = new HttpHeaders({
      'Authorization': `${token}`,
      'Content-Type': 'application/json'
    });
    
    options.headers = headers;
  } else {
      options.withCredentials = true;
  }
  
  return options;
}

 logout() {
   //localStorage.clear();
   sessionStorage.clear();
   this.authService.logout();
 }

  fetchBlocker(todayStart: any, todayEnd: any): Observable<any> {
      //if (typeof todayStart !== 'number' || typeof todayEnd !== 'number') {
      //  console.warn('Ungültige Parameter für fetchEvents:', todayStart, todayEnd);
      //  return of(null);
      //}
    const options = this.setFetchOptions();
    //console.log(options)
    //console.log('FETCH OPTIONS: ',options)
    return this.http.get(`${this.apiUrl}invalids/${todayStart}/${todayEnd}`, options).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.log("Unauthorized: Logging out");
          this.toastService.dangerToast(`Fehler beim laden der Blocker, kein Token gefunden`);
          this.logout();  // Falls 401, führe logout aus
        } else {
          this.toastService.dangerToast(`Fehler beim laden der Blocker`);
        }
        return of(null);
      })
    );
  }
}
